import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AiOutlineWarning } from 'react-icons/ai';
import styles from './popups.module.scss';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleRetry = () => {
    if (resetErrorBoundary) {
      resetErrorBoundary();
    }
  };

  return (
    <Modal show={true} onHide={handleGoToDashboard} centered>
      <Modal.Body className="text-center">
        <AiOutlineWarning className={styles.alertWarningIcon} />
        <h5>Something went wrong!</h5>
        {error && (
          <p className="text-muted small mt-2">
            {error.message || 'An unexpected error occurred'}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="mt-1 d-flex justify-content-center">
        {resetErrorBoundary && (
          <Button
            variant="outline-primary"
            onClick={handleRetry}
            className="me-2"
          >
            Try Again
          </Button>
        )}
        <Button variant="primary" onClick={handleGoToDashboard}>
          Go to Dashboard
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorFallback;
